export const getCalendarPlatform = (userAgent = navigator.userAgent || "") => {
  const value = String(userAgent);
  if (/iPad|iPhone|iPod/.test(value) || /Macintosh.*Mobile/.test(value)) {
    return "apple";
  }
  if (/Android/i.test(value)) {
    return "android";
  }
  return "other";
};
